// React context + hook for session state. Kept in its own file (rather
// than colocated with the provider) so the provider file only exports a
// component — satisfies react-refresh's "only components" rule.

import { createContext, useContext } from "react";
import type { ApiError } from "@/api";
import type { SessionMe } from "./types";

export type SessionStatus = "loading" | "authenticated" | "unauthenticated" | "error";

export interface SessionContextValue {
  status: SessionStatus;
  session: SessionMe | null;
  error: ApiError | null;
  refresh: () => Promise<void>;
}

export const SessionContext = createContext<SessionContextValue | undefined>(undefined);

export function useSession(): SessionContextValue {
  const ctx = useContext(SessionContext);
  if (!ctx) {
    throw new Error("useSession must be used inside <SessionProvider>");
  }
  return ctx;
}
